import http from './http';
import { listResource } from './listResource';

/**
 * Obtener lista de tipos de membresía
 */
export async function listMembershipTypes(options = {}) {
  return listResource('/membership-types', options);
}

/**
 * Obtener tipos para dropdown
 */
export async function getMembershipTypesDropdown() {
  const res = await http.get('/membership-types/dropdown');
  return res.data?.data ?? res.data;
}

/**
 * Obtener un tipo de membresía por ID
 */
export async function getMembershipTypeById(id) {
  const res = await http.get(`/membership-types/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Crear un nuevo tipo de membresía
 */
export async function createMembershipType(data) {
  const res = await http.post('/membership-types', data);
  return res.data?.data ?? res.data;
}

/**
 * Actualizar un tipo de membresía
 */
export async function updateMembershipType(id, data) {
  const res = await http.put(`/membership-types/${id}`, data);
  return res.data?.data ?? res.data;
}

/**
 * Eliminar (soft delete) un tipo de membresía
 */
export async function deleteMembershipType(id) {
  const res = await http.delete(`/membership-types/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Restaurar un tipo de membresía eliminado
 */
export async function restoreMembershipType(id) {
  const res = await http.patch(`/membership-types/${id}/restore`);
  return res.data?.data ?? res.data;
}

/**
 * Activar/desactivar un tipo de membresía
 */
export async function toggleMembershipTypeStatus(id, isActive) {
  const res = await http.patch(`/membership-types/${id}/toggle-active`, { isActive });
  return res.data?.data ?? res.data;
}